import styled from 'styled-components'
import { devices } from '../../../../globalStyle'

export const GridContainer = styled.div `
    display: grid;
    grid-template-areas:
    "titleNew titleNew titleNew titleNew"
    "cepLabel cep streetLabel street"
    "neighborhoodLabel neighborhood numberLabel number"
    "stateLabel state cityLabel city"
    "complementLabel complement complement complement"
    "line line line line"
    "daysLabel days hoursLabel hours"
   ;
    gap: 1rem;
    border: 1px dashed #ccc; 
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    grid-template-rows: auto; 
    padding: 2rem; 
    gap: 0rem; 
`


export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
`
export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 62.5vw auto;
    margin-right: 0.7vw;
    
`

export const HeaderText = styled.h1` 
font-family: 'Inter', sans-serif;
font-size: 2vw;
font-weight: 700;
margin-top: 0;
margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;
    
    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`
   
export const Text = styled.p` 
font-family: 'Inter', sans-serif;
font-size: 1rem;
font-weight: 700;
margin-top: 1rem;
margin-bottom: 0;
`

export const TextLabel = styled.p` 
font-family: 'Inter', sans-serif;
font-size: 1rem;
font-weight: 0.2vw;
margin-top: 1rem;
margin-bottom: 0;
color:  #303030;
`


export const OptionsDiv = styled.div `
    display: flex;
    justify-content: flex-end;
    grid-area: options;
    margin-top: 1vw;
    margin-bottom: 1vw;
    `

export const ButtonOfSection = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  height: 2.2vw;
  background-color: #0090d3;
  border-radius: 1vw;
  cursor: pointer;
  padding:.7vw;
  margin-right: 3vw;
  @media ${devices.largeDesktop} {
    width: 10vw;
  }

  &.reverse{
    background-color: #fff;
    border: 1px solid #0090d3;
  }
`

export const ButtonOfSectionText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  font-weight:700;
  padding-left: 0.5rem;
  padding-right: 0.5rem;

  @media ${devices.largeDesktop} {
    font-size: 0.6vw;
  }

  &.reverse{
    color: #0090d3;
  }
`

export const IconImg = styled.img`
  display: flex;
  height: 1.3vw;
  margin-right: 0.5vw;


  @media ${devices.largeDesktop} {
    height: 1vw;
  }
`

export const LineDiv = styled.div`
     background: #EBEBEB;
    
    height: 0.1px;
    grid-area: line;

    margin-top: 0.5vw;
` 